// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"ccabf894","728":"d00bc8db"}[chunkId] + ".chunk.js";
};